(function ($) {
	Drupal.behaviors.highlightSlider = {
		attach: function (context) {
			// reset/attach events
			Drupal.behaviors.highlightSliderAttachEvents(context);
		}
	}

	Drupal.behaviors.highlightSliderShow = function (target){

		$('.preloader').show();
		var $overlayContainer = $(target);

		var slider = $overlayContainer.addClass('active')
			.find('.content');

		slider.flickity({
			imagesLoaded: true,
			lazyload: true,
			fullscreen: true,
			fade: true,
			setGallerySize: false,
			prevNextButtons: true,
			pageDots: false,
			// autoPlay: 5000,
			dragThreshold: 0
		});

		var flkty = slider.data('flickity');

		var prevNextButtonGroup = $overlayContainer.find('.flickity-prev-next-button');
		var navButtonGroup = $overlayContainer.find('.highlight-overlay-nav-buttons-row');
		var navButtons = navButtonGroup.find('.highlight-overlay-nav-button');

		slider.on('select.flickity', function (event, index) {
			var oldNavButton = navButtons.filter('.is-selected');
			oldNavButton.removeClass('is-selected');
			var oldIndex = oldNavButton.index();
			navButtons.eq(flkty.selectedIndex).addClass('is-selected');

			// add video overlay click handler - prepare new video for slide if iframe does not already exist
			if (flkty.selectedElement && $(flkty.selectedElement).hasClass('.has-video')) {

				$overlayContainer.addClass('video-active');

				var video_src = $(flkty.selectedElement).find('.video-container').data('src');
				var iframe = $(flkty.selectedElement).find('.video-container iframe');
				iframe.src = "";
				iframe.src = video_src;
			}

			// destroy old video in last slide
			var	oldCell = flkty.cells[oldIndex];
			if(oldCell){
				var	oldSlide = $(oldCell.element);
				if (oldSlide) {
					var oldVideoSrc = oldSlide.find('.video-container').data('src');
					var oldIframe = oldSlide.find('.video-container iframe');
					oldIframe.src = "";
					oldIframe.src = oldVideoSrc;
				}
			}
		});

		prevNextButtonGroup.on('click', function () {

			//console.log("highlight-slider => click to flickity-prev-next-button");
			removeHighlightVideo();
		});

		navButtonGroup.on('click', '.highlight-overlay-nav-button', function () {

			//console.log("highlight-slider => click to highlight-overlay-nav-button");

			var index = $(this).index();
			slider.flickity('select', index);
			slider.focus();

			removeHighlightVideo();
		});

		// handle clicks to left/right screen areas
		slider.on('staticClick.flickity', function (event, pointer, cellElement, cellIndex) {

			//console.log("highlight-slider => click to left/right screen areas");

			// play button not in event target path
			event.stopPropagation();
			// handle double event fired (2 events fired with exact same timestamp)
			var lastEvent = slider.data('lastStaticEvent');
			if (lastEvent === event.originalEvent.timeStamp) {
				event.stopPropagation();
				event.preventDefault();
				return;
			} else {
				slider.data('lastStaticEvent', event.originalEvent.timestamp);
			}

			if(pointer.path){
				if (pointer.path.filter(function (el) { return jQuery(el).is('.highlight-play') }).length) {
					event.stopPropagation();
					event.preventDefault();
					return;
				}
			}

			removeHighlightVideo();

			var cellSize = cellElement.getBoundingClientRect();
			//if (window.innerWidth > 768) {

				var playIcon = $(event.target).hasClass("highlight-play");
				if(playIcon){
					return;
				}

				//area left
				if (pointer.offsetX < (cellSize.width / 2)) {
					slider.flickity('previous');

					//area right
				} else if (pointer.offsetX > (cellSize.width / 2)) {
					slider.flickity('next');
				}
			//}
		});
		slider.on( 'fullscreenChange.flickity', function( event, isFullscreen ) {
			if(!isFullscreen){
				$(target).find('.close').click();
			}
		});


		slider.flickity('viewFullscreen');

		// close button handler
		$(target).find('.close').unbind().click(function (event) {

			//console.log("highlight-slider => close click");

			//find and remove video
			/*
			var $content = $(this).siblings(".content");
			//console.log("close => content");
			var $selectedCard = $content.find(".card.is-selected");
			if($selectedCard){
				//console.log("close => is-selected");
				if($selectedCard.hasClass("has-video")){
					//console.log("close => has-video");
					if ( $selectedCard.find(".video-container").children().length > 0 ) {
						$selectedCard.find(".video-container").empty();
						$selectedCard.find("img").show();
						$selectedCard.find(".highlight-play").show();
						$(this).parent(".highlightOverlay").removeClass("video-active");
						return;
				   }
				}
			}
			*/

			//close highlight module
			$('.preloader').show();
			$(target).removeClass('active').find('.content').flickity('destroy');
			$('.preloader').fadeOut();
			$('html').removeClass('is-flickity-fullscreen');

			removeHighlightVideo();

		});



		setTimeout(function () {
			$('.preloader').fadeOut();
		}, 550);

	};

	function removeHighlightVideo(){
		//console.log("highlight-slider => removeHighlightVideo()");

		var videoContainer = $(".highlightOverlay").find('.video-container');
		if(videoContainer){
			videoContainer.each(function(){
				var video_src = $(this).data('src');
				var iframe = $(this).find('iframe');
				iframe.attr("src", "");
				iframe.attr("src", video_src);
			});
		}
	}

	Drupal.behaviors.highlightSliderAttachEvents = function (context){
		// reset/attach events
		$("[data-overlay-target]").each(function (index, el) {
			var target = '.' + $(el).data('overlayTarget');
			// remove links to artist gallery
			$(el).unbind();
			var showSlider = function (event) {
				// add target param to event
				Drupal.behaviors.highlightSliderShow(target);
			};
			$(el).click(showSlider);
		});
	}

})(jQuery);
